const padRunNo = (run: number | string): string => `${run}`.padStart(2, '0');

export default padRunNo;
